import React from "react";
import Variant from "shared/enums/Variant";
import { useCopies } from "shared/hooks/useCopies";
import { useManageByOrgAdmin } from "../../dataloader";
import { useCommonFeatures } from "context/commonFeatures";
import { ManageCellService, ManageOrgAdminCellProps } from "./types";

export default function useManageCellService(props: ManageOrgAdminCellProps): ManageCellService {
  const copies = useCopies();
  const { initConfirmationAlert } = useCommonFeatures();
  const { mutateAsync: manageByOrgAdmin } = useManageByOrgAdmin();

  const participantName = React.useMemo(
    () => `${props.row.original.firstName} ${props.row.original.lastName}`,
    [props.row.original.firstName, props.row.original.lastName]
  );

  const isParticipatingInProgram = React.useMemo(() => !!props.row.original.id, [props.row.original.id]);

  const changeHandler = React.useCallback(() => {
    initConfirmationAlert({
      message: (
        <span
          dangerouslySetInnerHTML={{
            __html: props.value
              ? copies.get("not.manage.confirm.message", {
                  0: participantName
                })
              : copies.get("manage.confirm.message", {
                  0: participantName
                })
          }}></span>
      ),
      primaryButtonVariant: props.value ? Variant.ERROR : Variant.SUCCESS,
      handleConfirm: () => {
        manageByOrgAdmin({
          orgAdminProgramParticipantId: props.orgAdminProgramParticipantId as string,
          uiVersion: props.programParticipantUiVersion,
          programParticipantId: props.row.original.id,
          selectToManage: !props.value
        }).then(data => {
          props.manageChangeHandler();
        });

        return true;
      }
    });
  }, [initConfirmationAlert, props, copies, participantName, manageByOrgAdmin]);

  return {
    participantName,
    changeHandler,
    isParticipatingInProgram
  };
}
